export function parseDateServerToDateObject(dateString: string): Date | null {
  if (!dateString) {
    return null
  }
  const year = parseInt(dateString.slice(0, 4), 10)
  const month = parseInt(dateString.slice(4, 6), 10) - 1 // Month is 0-based in Date object
  const day = parseInt(dateString.slice(6, 8), 10)
  const hour = parseInt(dateString.slice(8, 10), 10)
  const minute = parseInt(dateString.slice(10, 12), 10)
  const second = parseInt(dateString.slice(12, 14), 10)

  // Check if the parsed components are valid
  if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute) || isNaN(second)) {
    return null
  }

  return new Date(year, month, day, hour, minute, second)
}
